"use client";

import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { formatIsoStringDate } from "@/lib/utils";
import { GetLomdaV2ResponseType } from "@/features/storage/sheets/lomdaV2Sheet/hooks/useGetLomdaV2";
import { LomdaMetadata } from "@/lib/utils/lomda/types";
import { getLanguageLabel, t } from "@/lib/localization";

export default function LomdaV2SheetAside({
    lomda,
}: {
    lomda: GetLomdaV2ResponseType["data"];
}) {
    let language = "";
    try {
        const metadata = JSON.parse(lomda.metadata as string) as LomdaMetadata;
        language = getLanguageLabel(metadata.language);
    } catch {
        language = "-";
    }

    return (
        <aside className="flex flex-col w-full lg:w-[300px] xl:w-[400px] py-4 px-8 lg:pe-0 gap-4">
            <div className="bg-white flex flex-col p-4 rounded-md border w-full gap-6">
                <div>
                    <Label>
                        {t("lomda-sheet.aside.card.lomda-created-at.title", undefined, undefined)}
                    </Label>
                    <div className="mt-1">
                        <Input
                            disabled
                            className="!cursor-default !opacity-100 text-muted-foreground pe-9"
                            value={formatIsoStringDate(
                                lomda.createdAt as string,
                                true
                            )}
                        />
                    </div>
                </div>
                <div>
                    <Label>
                        {t("lomda-sheet.aside.card.lomda-updated-at.title", undefined, undefined)}
                    </Label>
                    <div className="mt-1">
                        <Input
                            disabled
                            className="!cursor-default !opacity-100 text-muted-foreground pe-9"
                            value={formatIsoStringDate(
                                lomda.updatedAt as string,
                                true
                            )}
                        />
                    </div>
                </div>
                <div>
                    <Label>
                        {t("lomda-sheet.aside.card.language.title", undefined, undefined)}
                    </Label>
                    <div className="mt-1">
                        <Input
                            disabled
                            className="!cursor-default !opacity-100 text-muted-foreground pe-9"
                            value={language}
                        />
                    </div>
                </div>
            </div>
        </aside>
    );
}
